import * as React from 'react';
import { ImageField, ReferenceField, Show, ShowProps, SimpleShowLayout, TextField } from 'react-admin';
import { MediaField } from '../components/MediaField';
import { TranslateField } from '../components/TranslateField';

export const SuccessStoryShow = (props: ShowProps): React.ReactElement => {
	return (
		<Show {...props}>
			<SimpleShowLayout>
				<TextField source="id" label="#"/>
				<MediaField source="featuredImageUrl" label="IMAGE_OR_VIDEO"/>
				<TextField source="title" label="TITLE"/>
				<TextField source="description" label="DESCRIPTION"/>
				<ReferenceField source="categoryId" reference="success-story-categories" label="CATEGORY">
					<TextField source="name"/>
				</ReferenceField>

				<ReferenceField source="createdById" reference="clients" label="CREATED_BY">
					<TextField source="fullName"/>
				</ReferenceField>

				<ImageField source="gallery" label="GALLERY"/>
				<TranslateField source="language" label="LANGUAGE"/>
			</SimpleShowLayout>
		</Show>
	);
};
